import {graphql} from '../../../__generated__';

export const QUERY_GROUPS = graphql(`
    query groups (
        $filters: GroupFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
        $filtersClients: ClientFiltersInput, $paginationClients: PaginationArg = {}, $sortClients: [String] = []
    ) {
        groups(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            name
            clients (filters: $filtersClients, pagination: $paginationClients, sort: $sortClients) {
                documentId
                firstName
                lastName
            }
        }
    }
`);

export const QUERY_SELECT_GROUPS = graphql(`
    query selectGroups (
        $filters: GroupFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
    ) {
        groups(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            name
        }
    }
`);

export const QUERY_GROUP = graphql(`
    query group (
        $documentId: ID!, $filtersClients: ClientFiltersInput, $paginationClients: PaginationArg = {}, $sortClients: [String] = []
    ) {
        group(documentId: $documentId) {
            documentId
            name
            clients (filters: $filtersClients, pagination: $paginationClients, sort: $sortClients) {
                documentId
                firstName
                lastName
                enabled
            }
        }
    }
`);

export const CREATE_GROUP = graphql(`
    mutation createGroup ($data: GroupInput!) {
        createGroup(data: $data) {
            documentId
        }
    }
`);

export const UPDATE_GROUP = graphql(`
    mutation updateGroup ($id: ID!, $data: GroupInput!) {
        updateGroup(documentId: $id, data: $data) {
            documentId
        }
    }
`);
